/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { VApplication } from "../../../application";
import { RECALL_UNUSED_INVITES } from "../graphql/recallUnused.mutation";
import { REINVITE_USER } from "../graphql/reinvite.mutate";

const log: any = LoggerModule?.getInstance();
const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IReInviteMethods extends IPluginMethodMap {
  reInviteUser(args: any): Promise<any>;
}

export class ReInviteUserService implements IAgentPlugin {
  readonly methods: IReInviteMethods;

  constructor() {
    this.methods = {
      reInviteUser: this.reInviteUser.bind(this),
    };
  }

  async reInviteUser(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    console.log("args reinvite==>", args)
    try {
      if (client) {
        const res = await client.mutate({
          mutation: REINVITE_USER,
          variables: {
            input: {
              isMasq: true,
              vuid: args?.vuid,
              presentation: args?.presentation,
              referal: args?.rid
            },
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          console.log("res?.data==>", res?.data);
          return {
            ...res?.data?.inviteUser,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
